module.exports = __webpack_public_path__ + "img/works_kiwoom_btm_off_m_.9ca300d0.png";